var t=function(t){return t.includes("AttributeType@")||t.includes("@AttributeType")},e=function(t){return t.includes("Attribute@")};export{e as isAttributeId,t as isAttributeTypeId};
//# sourceMappingURL=index.js.map
